import { Paper, Box, Typography } from '@mui/material';
import { useProjectContext } from 'contexts/project.context';
import { memo } from 'react';
import { Handle, NodeProps, Position } from 'reactflow';
import { ProjectStage } from 'store/api/models';

const StageNode = ({
  data,
  isConnectable,
  targetPosition = Position.Top,
  sourcePosition = Position.Bottom,
}: NodeProps<ProjectStage>) => {
  const { stages, project_stages } = useProjectContext();

  return (
    <>
      <Handle
        type="target"
        position={targetPosition}
        isConnectable={isConnectable}
      />
      <Paper elevation={5} sx={{ px: 3, pt: 1, pb: 3 }}>
        {data.name} stage
      </Paper>
      {/* {data?.label} */}
      {data.outcomes?.map((o, i) => (
        <Handle
          type="source"
          position={sourcePosition}
          isConnectable={isConnectable}
          id={o.name}
          title={o.name}
          style={{ left: `${(100 * (i + 1)) / (data.outcomes.length + 1)}%` }}
        >
          <Box
            sx={{
              position: 'relative',
              top: -20,
              // border: theme => `1px solid ${theme.palette.secondary.main}`,
            }}
          >
            <Typography
              variant="caption"
              sx={{ fontSize: '8px', lineHeight: 1 }}
            >
              {o.name}
            </Typography>
          </Box>
        </Handle>
      ))}
    </>
  );
};

StageNode.displayName = 'StageNode';

export default memo(StageNode);
